
import { Component, Vue } from 'vue-property-decorator';
import { mainStore, userToolStore, senffProposalStore, companyStore } from '@/store';
import DateComponent from '@/components/DateComponent.vue';
import LinkCardDialog from './LinkCardDialog.vue';
import _ from 'lodash';

@Component({
  components: {
    DateComponent,
    LinkCardDialog,
  },
})
export default class SolicitacoesCartaoSenff extends Vue {
  updateStatusIsLoading: boolean = false;
  isFranchise: boolean = true;
  openDialogLinkCard: boolean = false;
  tableIsLoading: boolean = false;

  invoice_aluno_link_card: any = null;
  proposal_id_link_card: string = null;
  senff_proposal_id_link_card: number = null;
  cnpj_company_link_card: string = null;

  selectedCompanyId: number = null;

  filters = {
    name: null,
  };

  get headers() {
    return [
      {
        text: 'Código',
        sortable: true,
        value: 'id',
        align: 'center',
      },
      {
        text: 'Data da inscrição',
        sortable: false,
        value: 'created_at',
        align: 'center',
      },
      {
        text: 'Nome do aluno',
        sortable: false,
        value: 'invoice_aluno.full_name',
        align: 'center',
      },
      {
        text: 'Status',
        sortable: false,
        value: 'status',
        align: 'center',
      },
      {
        text: 'Pré Análise',
        sortable: false,
        value: 'pre_proposal_completed',
        align: 'center',
      },
      {
        text: 'Informações Complementares',
        sortable: false,
        value: 'complement_submit',
        align: 'center',
      },
      {
        text: 'Proposta concluída',
        sortable: false,
        value: 'proposal_completed',
        align: 'center',
      },
      {
        text: 'Vincular cartão',
        sortable: false,
        value: 'link_card',
        align: 'center',
      },
      {
        text: 'Atualizar Status',
        sortable: false,
        value: 'update',
        align: 'center',
      },
    ];
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  get currentUserTools() {
    return (
      userToolStore.currentUserTools.find((t) => t.name === 'Senff Solicitações') || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get senffProposals() {
    let senffSolicitacoes = senffProposalStore.senffProposals;

    if (this.filters.name !== null && this.filters.name !== '') {
      senffSolicitacoes = senffSolicitacoes.filter((s) => {
        //@ts-ignore
        if (
          //@ts-ignore
          s.invoice_aluno.full_name.toLocaleLowerCase().includes(this.filters.name)
        ) {
          return s;
        }
      });
    }

    return senffSolicitacoes;
  }

  get companiesAutocomplete() {
    return companyStore.companiesAutocomplete;
  }

  getChipStyle(background_color, text_color) {
    const style = {
      color: `var(--v-${text_color})`,
      background: `var(--v-${background_color})`,
      border: `1px solid var(--v-${text_color})`,
    };
    return style;
  }

  linkCardDialog(invoice_aluno: any, proposal_id: string, senff_proposal_id: number) {
    this.invoice_aluno_link_card = invoice_aluno;
    this.proposal_id_link_card = proposal_id;
    this.senff_proposal_id_link_card = senff_proposal_id;
    this.handleDialogVisibility(true);
  }

  handleDialogVisibility(value: boolean) {
    this.openDialogLinkCard = value;
  }

  async refreshStatus(invoice_aluno_id: number) {
    this.updateStatusIsLoading = true;
    await senffProposalStore.getProposalsByAluno(invoice_aluno_id);
    this.updateStatusIsLoading = false;
  }

  clearFilters() {
    this.filters = {
      name: null,
    };
  }

  async reloadData() {
    this.tableIsLoading = true;
    if (this.selectedCompanyId) {
      await senffProposalStore.getProposalsCompany({
        company_id: this.selectedCompanyId,
        update_proposals: true,
      });
    }
    this.tableIsLoading = false;
  }

  created() {}

  async mounted() {
    this.tableIsLoading = true;
    if (this.currentUser.company.is_franchise) {
      await senffProposalStore.getProposalsCompany({
        company_id: this.currentUser.company_id,
        update_proposals: true,
      });
    } else {
      this.isFranchise = false;
      await companyStore.getCompaniesAutoComplete({
        is_active: true,
        is_franchise: true,
      });
      await senffProposalStore.getProposalsCompany({
        company_id: 1,
        update_proposals: false,
      });
    }
    this.tableIsLoading = false;
  }
}
